export default __webpack_public_path__ + "static/media/restaurant-banner@3x.8d4d7de9.png";